<div class="loader">
    <div class="animation-container">&nbsp;</div>
</div>